import "./event-schedule.scss";

import {
  EventScheduleItem,
  EventScheduleItemProps,
} from "./event-schedule-item";
import { Alignment } from "design-system/types/types";

export interface EventScheduleProps {
  schedule: Array<EventScheduleItemProps>;
  alignment?: Alignment;
}

/**
 * ## See it in use on...
 * - The [event/conference page](/story/example-pages-secondary-page-types--story)
 *
 * - **`id: CB-003-000-00`**
 * - **`data-region: cb__event-schedule`**
 */
export function EventSchedule({ schedule, alignment }: EventScheduleProps) {
  return (
    <div
      className={`hbs-global-align-${alignment ? alignment : "wide"}`}
      data-region="cb__event-schedule"
    >
      <div className="hbs-event-schedule">
        <ul
          className={`hbs-event-schedule__list${
            alignment === "center" ? "-no-border" : ""
          }`}
        >
          {schedule.map((item, i) => (
            <EventScheduleItem key={i} {...item} />
          ))}
        </ul>
      </div>
    </div>
  );
}
